var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9377 24.4207V5.0314C10.9377 3.19065 10.271 2.45435 8.61475 2.45435H4.40641C2.75016 2.45435 2.0835 3.19065 2.0835 5.0314V24.4207C2.0835 26.2614 2.75016 26.9977 4.40641 26.9977H8.61475C10.271 26.9977 10.9377 26.2614 10.9377 24.4207Z",
    fill: "#688FB6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M22.9167 15.8305V5.0314C22.9167 3.19065 22.25 2.45435 20.5938 2.45435H16.3854C14.7292 2.45435 14.0625 3.19065 14.0625 5.0314V15.8305C14.0625 17.6712 14.7292 18.4075 16.3854 18.4075H20.5938C22.25 18.4075 22.9167 17.6712 22.9167 15.8305Z",
    fill: "#F04835"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.f93a5addda4a90deec4df11b6f94c82c.svg";
export { ForwardRef as ReactComponent };